import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rootRoute } from '../__root';
import { requireGuest } from '@/lib/route-guards';

export const forgotPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/auth/forgot-password',
  beforeLoad: requireGuest,
  component: lazyRouteComponent(
    () => import('@/features/auth/ForgotPasswordPage'),
    'ForgotPasswordPage',
  ),
});
